import { reducer as form } from 'redux-form';

import * as FormUtils from 'utils/form';

/**
 * Calculates new value based on limit when total changes, otherwise just
 * formats
 */
function volumeNormalizer(value, previousValue, allValues, previousAllValues) {
  if (allValues.total !== previousAllValues.total) {
    // Total changed, update volume

    const total = FormUtils.normalizeNumber(allValues.total);
    const limit = FormUtils.normalizeNumber(allValues.limit);

    value = Math.floor(total / limit);
  }

  return FormUtils.formatNumber(value) || '';
}

/**
 * Calculates the new value when other values change, otherwise just formats
 */
function totalNormalizer(value, previousValue, allValues, previousAllValues) {
  const limit = FormUtils.normalizeNumber(allValues.limit);
  const volume = FormUtils.normalizeNumber(allValues.volume);

  if (allValues.limit !== previousAllValues.limit) {
    // Limit changed
    value = limit * volume;
  } else if (allValues.volume !== previousAllValues.volume) {
    // Volume changed
    value = limit * volume;
  }

  return FormUtils.formatNumber(value) || '';
}

function triggerPriceNormalizer(value, previousValue, allValues) {
  if (allValues.triggerTerms === 'none') {
    return '0,00';
  }

  return FormUtils.formatNumber(value) || 0;
}

const defaultNormalizers = {
  volume: volumeNormalizer,
  limit: value => FormUtils.formatNumber(value),
  total: totalNormalizer,
  triggerPrice: triggerPriceNormalizer,
  visible: value => FormUtils.formatNumber(value),
};

// Return reducer that formats values according to
// rules for fields
export default form.normalize({
  buyComponent: defaultNormalizers,
  sellComponent: defaultNormalizers,
  advancedBuyComponent: defaultNormalizers,
  advancedSellComponent: defaultNormalizers,
  fictiveBuyComponent: defaultNormalizers,
  fictiveSellComponent: defaultNormalizers,
  newTransactionBuyComponent: defaultNormalizers,
  newTransactionSellComponent: defaultNormalizers,
});
